import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { JustinoControlAccesoService } from '../../../services/justino-control-acceso.service';

@Component({
  selector: 'app-recuadro-justino',
  templateUrl: './recuadro-justino.component.html',
  styleUrl: './recuadro-justino.component.scss'
})
export class RecuadroJustinoComponent {

  constructor(
    private router: Router,
  ) { }

  redirectToJustino(): void {
    this.router.navigate(['/justino/bot']);
  }
}
